import styled from 'styled-components';

const LoginSComponent = styled.section`
  align-items: center;
  background-image: linear-gradient(0deg, #350b4b 0%, #ffb703 74%);
  display: flex;
  height: 100vh;
  justify-content: center;
  zoom: 1; /* Trigger hasLayout */
`;

export default LoginSComponent;
